import { FilterMatchMode } from 'primereact/api'

export const matchConstraints = (value, filter) => {
    if (!filter || !Array.isArray(filter.constraints) || filter.constraints.length === 0) return true

    const { operator, constraints } = filter

    if (operator === 'and') {
        return constraints.every(constraint => {
            if (constraint.value === null) return true
            return matchFilter(value, constraint.value, constraint.matchMode)
        })
    } else if (operator === 'or') {
        return constraints.some(constraint => {
            if (constraint.value === null) return true
            return matchFilter(value, constraint.value, constraint.matchMode)
        })
    }

    return true
}

export const matchFilter = (val, filterVal, matchMode) => {
// Special handling for __EMPTY__ placeholder - match null/empty values
if (filterVal === '__EMPTY__') {
    return val === null || val === undefined || val === '' || val === '-'
}
    
if (val == null || filterVal == null) return false

const value = typeof val === "string" ? val.toUpperCase() : val
const filterValue = typeof filterVal === "string" ? filterVal.toUpperCase() : filterVal

    // Handle string matchMode values from PrimeReact
    switch (matchMode) {
        case FilterMatchMode.STARTS_WITH:
        case 'startsWith':
            return value.startsWith(filterValue)
        case FilterMatchMode.CONTAINS:
        case 'contains':
            return value.includes(filterValue)
        case FilterMatchMode.EQUALS:
        case 'equals':
            return value === filterValue
        case FilterMatchMode.NOT_EQUALS:
        case 'notEquals':
            return value !== filterValue
        case FilterMatchMode.ENDS_WITH:
        case 'endsWith':
            return value.endsWith(filterValue)
        case FilterMatchMode.LESS_THAN:
        case 'lt':
            return value < filterValue
        case FilterMatchMode.LESS_THAN_OR_EQUAL:
        case 'lte':
            return value <= filterValue
        case FilterMatchMode.GREATER_THAN:
        case 'gt':
            return value > filterValue
        case FilterMatchMode.GREATER_THAN_OR_EQUAL:
        case 'gte':
            return value >= filterValue
        case FilterMatchMode.CUSTOM:
        case 'custom':
            return value?.trim() === filterValue?.trim()
        default:
            return false
    }
}
